import { useState } from 'react';
import classNames from 'classnames/bind';
import styles from '@/styles/superstack/base/ToggleButton.module.scss';
import ImageToggleActive from '@/asset/superstack/svgs/toggle-btn-active.svg';
import ImageToggleInActive from '@/asset/superstack/svgs/toggle-btn-inactive.svg';
import PropTypes from 'prop-types';

// eslint-disable-next-line no-unused-vars
const ToggleButton = ({ size, name, active, updateContainer, ...props }) => {
  const cx = classNames.bind(styles);
  const [isActive, setIsActive] = useState(active || false);
  const img = isActive ? <ImageToggleActive /> : <ImageToggleInActive />;

  const handleToggle = () => {
    setIsActive(!isActive);
    if (updateContainer) {
      updateContainer();
    }
  };

  return (
    <>
      <span className={cx('toggle-btn')} onClick={handleToggle}>
        {img}
      </span>
    </>
  );
};

ToggleButton.prototype = {
  size: PropTypes.string,
  name: PropTypes.string,
  active: PropTypes.bool,
};
ToggleButton.defaultProps = {
  size: 'sm',
  name: 'test',
  active: false,
};

export { ToggleButton };
